import { useTranslationContext } from '../../context/TranslationContext';
// Components/ui
import { BasicInputContainer, InputContainer } from '../../layout';
import { TextField, Typography } from '@mui/material';
// Types
import { UseFieldType } from '../../hooks/useField';

type TitleTextFieldProps = {
  titleField: UseFieldType;
  disabled: boolean;
  variantMode?: 'default' | 'inline';
};

const TitleTextField = ({ titleField, disabled, variantMode = 'default' }: TitleTextFieldProps) => {
  const t = useTranslationContext();
  // Desestructurar para controlar el value y type
  const { value, type, ...restAttributes } = titleField.attributes;
  const safeValue = value || '';

  if (variantMode === 'inline') {
    return (
      <TextField
        {...restAttributes}
        value={safeValue}
        disabled={disabled}
        autoFocus
        fullWidth
        // importante: fallback para que no se vea la key si falta traducción
        placeholder={t('global.addTitle')}
        variant="standard"
        // No pasar type en variant=standard para evitar conflictos
        InputProps={{
          // <-- NO lo deshabilites, queremos la línea
          disableUnderline: false,
          sx: { fontSize: 22, fontWeight: 500 },
        }}
        sx={{
          // underline gris normal
          '& .MuiInput-underline:before': { borderBottomColor: 'divider' },
          // underline gris en hover
          '& .MuiInput-underline:hover:before': { borderBottomColor: 'text.secondary' },
          // underline azul en focus (como Google)
          '& .MuiInput-underline:after': { borderBottomWidth: 2 },
        }}
      />
    );
  }

  // Modo vista: mostrar como texto estático
  if (disabled) {
    return (
      <InputContainer title={t('global.title')}>
        <Typography variant="body1" sx={{ py: 0.5, color: (theme) => theme.palette.text.secondary, fontSize: '0.9rem' }}>
          {safeValue || '-'}
        </Typography>
      </InputContainer>
    );
  }

  return (
    <InputContainer title={t('global.title')}>
      <TextField
        {...restAttributes}
        value={safeValue}
        disabled={disabled}
        autoFocus
        fullWidth
        variant="standard"
        size="small"
        type={type}
      />
    </InputContainer>
  );
};

export default TitleTextField;
